import {
    AnotherKPIOperand,
    BaseStatement,
    Constant,
    DashboardFilterOperand,
    DateAddBusinessFunctionOperand,
    DateDiffBusinessFunctionOperand,
    FieldOperand,
    IsBusinessDateFunctionOperand,
    KnownVariable,
    MathExpression,
    NewVariableOperand,
    NullOperand,
    Operator,
    ParameterOperand,
    RFunctionOperand,
    SpecialAggregationFunctionOperand,
    SQLFunctionOperand,
    StoredConstant,
    UserFilterOperand
} from '@InstanceFactory';
import { StatementVisitorBase } from '@Studio/StatementVisitorBase';

export type AllVisitorFunction<TStatement extends BaseStatement = BaseStatement> = {
    [TKey in keyof TraverseStatement]?: TraverseStatement[TKey] extends (arg: TStatement) => void ? TraverseStatement[TKey] : never;
};

export class TraverseStatement extends StatementVisitorBase {
    constructor(private readonly params: AllVisitorFunction) {
        super();
        for (const [key, func] of Object.entries(params)) {
            const oldFun = this[key];
            this[key] = statement => {
                func.call(this, statement);
                oldFun.call(this, statement);
            };
        }
    }

    public visitMath(mathExpression: MathExpression): void {
        super.visitMath(mathExpression);
    }

    public visitSqlFunction(sqlFunction: SQLFunctionOperand): void {
        super.visitSqlFunction(sqlFunction);
    }

    public visitField(field: FieldOperand): void {
        super.visitField(field);
    }

    public visitConstant(constant: Constant): void {
        super.visitConstant(constant);
    }

    public visitNull(nullOperand: NullOperand): void {
        super.visitNull(nullOperand);
    }

    public visitStoredConstant(storedConstant: StoredConstant): void {
        super.visitStoredConstant(storedConstant);
    }

    public visitOperator(operator: Operator): void {
        super.visitOperator(operator);
    }

    public visitQueryParameter(queryParameter: ParameterOperand): void {
        super.visitQueryParameter(queryParameter);
    }

    public visitKnownVar(knownVar: KnownVariable): void {
        super.visitKnownVar(knownVar);
    }

    public visitNewVar(newVar: NewVariableOperand): void {
        super.visitNewVar(newVar);
    }

    public visitMetric(metric: AnotherKPIOperand): void {
        super.visitMetric(metric);
    }

    public visitRFunction(rFunction: RFunctionOperand): void {
        super.visitRFunction(rFunction);
    }

    public visitDateDiffBusinessFunction(dateDiffFunction: DateDiffBusinessFunctionOperand): void {
        super.visitDateDiffBusinessFunction(dateDiffFunction);
    }

    public visitDateAddBusinessFunction(dateAddFunction: DateAddBusinessFunctionOperand): void {
        super.visitDateAddBusinessFunction(dateAddFunction);
    }

    public visitIsBusinessDateFunction(isBusinessDateFunction: IsBusinessDateFunctionOperand): void {
        super.visitIsBusinessDateFunction(isBusinessDateFunction);
    }

    public visitUserFilter(userFilter: UserFilterOperand): void {
        super.visitUserFilter(userFilter);
    }

    public visitDashboardFilter(userFilter: DashboardFilterOperand): void {
        super.visitDashboardFilter(userFilter);
    }

    public visitSpecialAggregationFunction(specialAggreationFunction: SpecialAggregationFunctionOperand): void {
        super.visitSpecialAggregationFunction(specialAggreationFunction);
    }
}
